/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { UserEmailChangeRequestModel } from '../../models/user-email-change-request-model';

export interface UserEmailChangeRequestPostParams {
  userGuid: string;
  body: UserEmailChangeRequestModel;
}

export function userEmailChangeRequestPost(
  http: HttpClient,
  rootUrl: string,
  params: UserEmailChangeRequestPostParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(
    rootUrl,
    userEmailChangeRequestPost.PATH,
    'post',
  );

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.path('userGuid', params.userGuid, { style: 'simple' });
  rb.body(params.body, 'application/json');

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => {
        return r as StrictHttpResponse<void>;
      }),
    );
}

userEmailChangeRequestPost.PATH =
  '/api/v1/users/{userGuid}/email-change/request';
